/*
 * @Description: 导出模板
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2020-08-18 15:06:55
 */

import React from 'react';
import ExportLayout from '../../components/ExportLayout';
import getComponent, {router} from './getComponent';

class Layout extends React.Component {

  render () {
    const links = Object.keys(router)

    return (
      <ExportLayout links={links}>
        {this.props.children}
      </ExportLayout>
    )
  }
}

const title = '报告自动化';

export default {

  path: '/exportPDF',
  async action(...res) {
    return //console.log(res)
  },
  children: [
    {
      path: '/',
      action () {
        const SetPage = getComponent('SetPage');
        return {
          title,
          component: <Layout>
            <SetPage></SetPage>  
          </Layout>
        }
      }
    },
    {
      path: '/SetPage',
      action () {
        const SetPage = getComponent('SetPage');
        return {
          title,
          component: <Layout>
            <SetPage></SetPage>  
          </Layout>
        }
      }
    },
    {
      path: '/:page',
      action (context) {
        const current = context.params.page;
        const Page = getComponent(current)

        return {
          title: `${title}-第${current}页`,
          component: <Layout>
            <Page></Page>
          </Layout>
        }
      }
    }
  ]

};



// WEBPACK FOOTER //
// src/routes/exportPDF/index.js